export const MAIN_DRAWER_WIDTH = 672;
export const MEMBERS_DRAWER_WIDTH = 430;
